// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"Parceiros_containerPrincipal__QSlbL","containerParceiros":"Parceiros_containerParceiros__DesHr","divParceiro":"Parceiros_divParceiro__RYVsk"};